import type { z } from 'zod';

import { UUID } from './uuid';

export const DomainSessionId = UUID;

export type DomainSessionId = z.infer<typeof DomainSessionId>;
